module.exports = __webpack_public_path__ + "static/crab-2-c0ca4fe71678d8a3bf1caf02768d0780.png";